<template>
  <sweet-modal ref="modal" icon="success" hide-close-button>
    <p>{{ $t('modals.success_message') }}</p>
    <p v-if="customMessage">{{ customMessage }}</p>
    <template #button>
      <button class="btn btn-default" @click="close">
        {{ $t('modals.close_button') }}
      </button>
    </template>
  </sweet-modal>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
import {SweetModal} from 'sweet-modal-vue-3';

export default {
  name: 'SuccessModal',
  components: {
    SweetModal
  },
  computed: mapState({
    success: state => state.success,
    customMessage: state => state.customMessage
  }),
  methods: {
    ...mapMutations(['setCustomMessage']),
    open: function () {
      this.$refs.modal.open();
    },
    close: function () {
      this.setCustomMessage(undefined);
      this.$refs.modal.close();
    }
  },
  watch: {
    success: function (newValue) {
      if (newValue !== undefined && newValue === true) {
        this.$refs.modal.open();
      }
    }
  }
};
</script>

<style>
.sweet-modal-success {
  margin-top: 11%;
}
</style>
